import { BackButton } from "../../dispatching-planning/common/back-button";
import { CloseButton } from "../../dispatching-planning/common/close-button";
import { useTranslation } from "react-i18next";
import SavedLocationTypeSelectionOption from "./SavedLocationTypeSelectionOption";
import { SavedLocationType } from "./SavedLocation";
import DeliveryLocationForm from "../../DeliveryLocationForm";
import "./AddEditSavedLocation.scss";

const AddDeliveryLocation = ({
  clientId,
  onClose,
  onBack,
  onTypeChange,
}: {
  clientId: string;
  onClose: () => void;
  onBack: () => void;
  onTypeChange: (type: SavedLocationType) => void;
}) => {
  const { t } = useTranslation(["modals"]);

  return (
    <div className="favorites-terminals-dialog__container">
      <div className="favorites-terminals-dialog__title">
        <div className="favorites-dialog-title__left">
          <BackButton onClick={onBack} />
          <div className="add-edit-favorites-terminals__title">
            {t("modals:manageSavedLocations.addPlace")}
          </div>
        </div>
        <CloseButton onClick={onClose} />
      </div>
      <div
        className="add-edit-favorites-terminals__type-selections"
        role="radiogroup"
      >
        <SavedLocationTypeSelectionOption
          type="favorite"
          active={false}
          onClick={() => onTypeChange("FAVORITE")}
          hasCheckIcon
        />
        <SavedLocationTypeSelectionOption
          type="terminal"
          active={false}
          onClick={() => onTypeChange("TERMINAL")}
          hasCheckIcon
        />
        <SavedLocationTypeSelectionOption
          type="delivery"
          active
          onClick={() => {}}
          hasCheckIcon
        />
      </div>
      <DeliveryLocationForm
        clientId={clientId}
        onSaved={onBack}
        onCancel={onClose}
      />
    </div>
  );
};

export default AddDeliveryLocation;
